import { Modal as AModal } from 'antd';
import type { ModalProps } from 'antd/es/modal';

const Modal: React.FC<ModalProps> = props => {
  return <AModal
    centered
    maskClosable={false}
    { ...props }
  ></AModal>;
};

export default Modal;